<div class="admin-page milk-page">
    @if (isLoading) {
    <div class="admin-state">
        <mat-spinner diameter="32"></mat-spinner>
        <span>Carregando controles…</span>
    </div>
    } @else if (hasError) {
    <div class="admin-state error">
        <mat-icon>error_outline</mat-icon>
        <span>Não foi possível carregar os controles leiteiros.</span>
    </div>
    } @else if (milkControls?.length) {
    <div class="admin-toolbar">
        <h3>Controles leiteiros</h3>
        <span class="admin-count">{{ milkControls.length }}</span>
    </div>
    <div class="table" role="table">
        <div class="thead" role="row">
            <span role="columnheader">Início</span>
            <span role="columnheader">Animais por ordenha</span>
            <span role="columnheader">Origem</span>
            <span role="columnheader">Status</span>
            <span role="columnheader" class="actions-h">Ações</span>
        </div>
        @for (control of milkControls; track control.id) {
        <div
            class="row"
            role="button"
            tabindex="0"
            [class.open]="control.isOpenStatus"
            (click)="onOpenAnimals(control)"
            (keydown.enter)="onOpenAnimals(control)"
            title="Ver animais"
        >
            <div class="cell when" role="cell">
                <b>{{ control.formattedStartDate }}</b>
                <small>{{ control.formattedStartTime }}</small>
            </div>
            <div class="cell milks" role="cell">
                @if (control.milkings?.length) {
                <ul class="ordenhas">
                    @for (milking of control.milkings; track milking.id; let i = $index) {
                    <li>
                        <span class="ord">{{ i + 1 }}ª</span>
                        <b>{{ milking.totalMilkedAnimals }}</b>
                        <small>animais</small>
                    </li>
                    }
                </ul>
                } @else {
                <span class="none">{{ control.milkingsCount || 0 }}</span>
                }
            </div>
            <div class="cell origin" role="cell">
                <span class="pill origin-pill" [class]="control.originClass">{{ control.originLabel }}</span>
            </div>
            <div class="cell status" role="cell">
                <span class="pill" [class.on]="control.isOpenStatus" [class.off]="!control.isOpenStatus">
                    {{ control.controlStatus }}
                </span>
            </div>
            <div class="cell actions" role="cell" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                <button
                    type="button"
                    mat-icon-button
                    (click)="onPdf(control)"
                    [disabled]="pdfId === control.id"
                    aria-label="Gerar PDF do controle"
                    title="PDF do controle"
                >
                    @if (pdfId === control.id) {
                    <mat-spinner diameter="18"></mat-spinner>
                    } @else {
                    <mat-icon>picture_as_pdf</mat-icon>
                    }
                </button>
                <button
                    type="button"
                    mat-icon-button
                    (click)="onExportJson(control)"
                    [disabled]="exportingId === control.id"
                    aria-label="Gerar JSON para importar"
                    title="Gerar JSON para importar"
                >
                    @if (exportingId === control.id) {
                    <mat-spinner diameter="18"></mat-spinner>
                    } @else {
                    <mat-icon>download</mat-icon>
                    }
                </button>
                @if (control.isOpenStatus) {
                <button
                    type="button"
                    mat-icon-button
                    color="warn"
                    (click)="onDeleteControl(control)"
                    aria-label="Excluir controle"
                    title="Excluir"
                >
                    <mat-icon>delete_outline</mat-icon>
                </button>
                }
            </div>
        </div>
        }
    </div>
    } @else {
    <div class="state">
        <span>Nenhum controle leiteiro encontrado.</span>
    </div>
    }
</div>
